import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Table,
  Empty,
  Drawer,
  Row,
  Col,
  Popconfirm,
  notification,
  Tooltip,
  message,
  Button,
  Tabs,
} from "antd";
import {
  BankOutlined,
  DeleteOutlined,
  MenuUnfoldOutlined,
  EditOutlined,
  CheckOutlined,
  FileExcelOutlined,
  EyeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import TenantAccountUpdateForm from "../Forms/TenantAccountUpdateForm";
import moment from "moment";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper, RowHelper } from "util/TableHelper";
import { odata, queryHelper } from "../Filters/Helper";
import TenantAccountTableFilter from "../Filters/TenantAccountTableFilter";
import useSavedFilter from "../Filters/Helper/useSavedFilter";
import { SAVED_FILTER_PAGE_KEYS } from "../Filters/Helper/savedFilter";
import config from "../../util/ApiforContext";
import CashAccountAddForm from "../Forms/CashAccountAddForm";
import { useTranslation } from "react-i18next";

const userId = localStorage.getItem("userId");
const BankPage = () => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [updateFormData, setUpdateFormData] = useState();
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isNotification, setIsNotification] = useState([]);
  const [isShownErpBankBalance, setIsShownErpBankBalance] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [tableRoles, setTableRoles] = useState({});
  const { TabPane } = Tabs;
  const [addCashAccountVisibility, setAddCashAccountVisibility] =
    useState(false);
  const history = useHistory();
  const [hasErp, setHasErp] = useState(false);
  const [isSendTosVirmanUnApproved, setIsSendTosVirmanUnApproved] = useState(false);

  const {
    hasSavedFilter,
    loading: savedFilterLoading,
    saveCurrent,
    deleteCurrent,
  } = useSavedFilter(SAVED_FILTER_PAGE_KEYS.TenantAccountList, {
    onApply: (saved) => {
      setTableDataQueryOptions((prevState) => ({
        ...prevState,
        skip: 0,
        current: 1,
        filter: saved.filter || "",
        values: saved.values || {},
      }));
    },
  });

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  useEffect(() => {
    RequestHandler.get(`/user/IsAdmin?userId=${userId}`).then((response) => {
      setIsAdmin(response);
    });
    RequestHandler.get(
      `/TenantAccountParameter/GetTenantAccountParameter`
    ).then((response) => {
      if (response.success) {
        setTableRoles(response.data ?? {});
      }
    });
    getTenantParameter();

    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {

        setHasErp(true);
      }
    });
  }, []);

  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setIsNotification(response.isHasTransactionNotification);
        setIsShownErpBankBalance(response.isShownErpBankBalance);
        setIsSendTosVirmanUnApproved(response.isSendTosVirmanUnApproved);
      }
    });
  };

  useEffect(() => {
    if (isNotification == true) {
      const intervalId = setInterval(() => {
        RequestHandler.get(`/AccountTransaction/NotificationControl`).then(
          (res) => {
            if (res) accountTransactionNotification();
          }
        );
      }, 5 * 60 * 1000); // 5 dakika = 5 * 60 * 1000 ms
      return () => clearInterval(intervalId);
    }
  }, [isNotification]);

  const accountTransactionNotification = () => {
    notification.close("finekra2");
    notification.info({
      message: t("updatedAccountBalancesExist"),
      style: { height: 160 },
      description: (
        <div>
          <div>{t("clickToSeeUpdatedBalances")}</div>
          <Button
            style={{ marginTop: 5, position: "absolute", right: 20 }}
            type="primary"
            onClick={() => {
              notification.close("finekra2");
              getTableData();
            }}
          >
            <EyeOutlined /> {t("view")}
          </Button>
        </div>
      ),
      duration: 0,
      key: "finekra2",
    });
  };

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };
  const getExcelQuery = () => {
    const filterQuery = getFilterQuery();
    const orderQuery = tableDataQueryOptions.order
      ? tableDataQueryOptions.order.replace(/^&/, "")
      : "";

    if (filterQuery && orderQuery) {
      return `${filterQuery}&${orderQuery}`;
    }
    return filterQuery || orderQuery;
  };
  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };
  const getTableData = () => {
    setSelectedRowKeys([]);
    setTableData({
      ...tableData,
      loading: true,
    });
    const { skip, take, order, activeTab } = tableDataQueryOptions;
    let filter = getFilterQuery();

    if (activeTab != "1" && activeTab != undefined) {
      let queryDateTime = new Date(
        new Date().getTime() - 60 * 60 * 1000
      ).toISOString();

      let dateTimeFilter =
        activeTab == "2"
          ? `(lastQueryDate ge ${queryDateTime})`
          : `(lastQueryDate lt ${queryDateTime} or lastQueryDate eq null)`;
      filter +=
        filter != "" ? `and ${dateTimeFilter}` : `$filter=${dateTimeFilter}`;
    }

    RequestHandler.get(
      `/TenantAccount?$count=true&${filter}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };
  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      activeTab: tabKey,
    });
  };
  const paging = (p, _, sorter) => {
    let orderValue = "";
    if (sorter.columnKey && sorter.order) {
      orderValue =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }

    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
        order: orderValue,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.post(`/TenantAccount/PassiveAccount/${id}`).then(
      (response) => {
        if (response.success) {
          getTableData();
        }
      }
    );
  };

  const handleOnClickMultipleDelete = () => {
    const selectedRowsData = tableData.data
      .filter((row) => selectedRowKeys.includes(row.id))
      .map((row) => row.id);

    RequestHandler.post(
      `/TenantAccount/PassiveAccounts`,
      selectedRowsData
    ).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const showDrawerUpdate = (value) => {
    RequestHandler.get(`/TenantAccount/getbyid/${value}`).then((response) => {
      setUpdateFormData(response);
      setVisibleUpdate(true);
    });
  };

  const onCloseUpdate = () => setVisibleUpdate(false);

  const onAddCashAccountSuccess = () => {
    getTableData();
    setAddCashAccountVisibility(false);
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading(t("excelDownloading"), 0);

    RequestHandler.post(
      `/TenantAccount/ExportExcel`,
      {
        query: getExcelQuery(),
      },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${config.apiUrl
          }/TenantAccount/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  const columns = [
    {
      title: t("bank"),
      dataIndex: "bankLogo",
      key: "bankName",
      sorter: true,
      render: (data) => {
        return (
          <div style={{ width: 100 }}>
            <img src={data}></img>
          </div>
        );
      },
    },
    {
      title: t("branchNameOrCode"),
      dataIndex: "branchName",
      align: "center",
      key: "branchName",
      width: "15%",
      render: (text, row) => (
        <Tooltip placement="topLeft" title={text}>
          <div>
            {row.branchName == null
              ? row.branchCode == null
                ? ""
                : row.branchCode
              : row.branchName}
          </div>
        </Tooltip>
      ),
    },
    {
      title: t("accountName"),
      dataIndex: "name",
      align: "center",
      key: "name",
      width: "10%",
    },
    {
      title: t("ibanOrAccountNumber"),
      dataIndex: "iban",
      align: "center",
      key: "iban",
      width: "15%",
      sorter: true,
      render: (_, row) => (row.iban ? row.iban : row.accountNumber),
    },
    {
      title: t("currency"),
      dataIndex: "currency",
      align: "center",
      key: "currency",
      width: "10%",
    },
    {
      title: t("balance"),
      dataIndex: "balanceString",
      key: "balance",
      sorter: true,
      align: "center",
      render: (data) => (
        <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>{data}</div>
      ),
    },
    isShownErpBankBalance ? {
      title: t('erpBalance'),
      dataIndex: 'erpBalanceString',
      key: 'erpBalanceString',
      align: 'center',
      render: (text, row, index) => {
        {
          return <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>{text}</div>
        }
      },
    } : {},
    tableRoles.isBlockedBalance === true
      ? {
        title: t("blockedAmount"),
        dataIndex: "blockedAmountString",
        key: "blockedAmount",
        sorter: true,
        align: "center",
        render: (data) => (
          <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
            {data}
          </div>
        ),
      }
      : {},
    tableRoles.isAvailableBalance === true
      ? {
        title: t("availableBalance"),
        dataIndex: "availableBalanceString",
        key: "availableBalance",
        sorter: true,
        align: "center",
        render: (data) => (
          <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
            {data}
          </div>
        ),
      }
      : {},
    tableRoles.isAvailableCreditBalance === true
      ? {
        title: t("availableCreditBalance"),
        dataIndex: "availableCreditBalanceString",
        key: "availableCreditBalance",
        sorter: true,
        align: "center",
        render: (data) => (
          <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
            {data}
          </div>
        ),
      }
      : {},
    tableRoles.isAvailableInterestRate === true
      ? {
        title: t("interestRate"),
        dataIndex: "interestRate",
      }
      : {},
    tableRoles.isNetBalance === true ? {
      title: t("netBalance"),
      dataIndex: "netBalanceString",
      sorter: true,
      align: "center",
      render: (data) => (
        <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
          {data}
        </div>
      ),
      } : {},
    {
      title: t("type"),
      dataIndex: "type",
      align: "center",
      key: "type",
      width: "10%",
      render: (_, row) => {
        if (row.typeValue != null) {
          return <div>{row.type}</div>;
        }
      },
    },
    {
      title: t("lastQueryDate"),
      dataIndex: "lastQueryDate",
      key: "lastQueryDate",
      sorter: true,
      align: "center",
      render: (data) =>
        data ? (
          <div>
            {moment(data).format("L")} {moment(data).format("LT")}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: t("detail"),
      dataIndex: "",
      width: "2%",
      align: "center",
      render: (record) => {
        return (
          <Link
            style={{ fontSize: "150%" }}
            to={`/bank-accounts-account-transaction/${record.id}`}
          >
            <MenuUnfoldOutlined />
          </Link>
        );
      },
    },
    {
      title: t("includeInCalculation"),
      dataIndex: "isCalculated",
      width: "2%",
      align: "center",
      render: (data) => (
        <div style={{ color: data === true ? "green" : "red" }}>
          <CheckOutlined />
        </div>
      ),
    },

    isAdmin === true && hasErp ? {

      title: t("excludeFromErpTransfer"),
      dataIndex: "excludeFromErpTransfer",
      width: "2%",
      align: "center",
      render: (data) => (
        <div style={{ color: data === true ? "green" : "red" }}>
          <CheckOutlined />
        </div>
      ),

    } : {},
    {
      title: t("edit"),
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data) => (
        <a
          onClick={() => showDrawerUpdate(data)}
          style={{ color: "orange", fontSize: "130%" }}
        >
          <EditOutlined />
        </a>
      ),
    },
    isAdmin === true
      ? {
        title: t("delete"),
        dataIndex: "id",
        align: "center",
        render: (data, row) => (
          <Popconfirm
            title={t("accountWillBeDeactivated")}
            okText={t("okDelete")}
            cancelText={t("noDontDelete")}
            onConfirm={() => handleOnClickDelete(data)}
            disabled={row.isSystemAccount}
          >
            <a>
              <DeleteOutlined
                style={{
                  color: row.isSystemAccount ? "gray" : "red",
                  fontSize: "130%",
                }}
              />
            </a>
          </Popconfirm>
        ),
      }
      : {},
  ];

  const detailColumns = [
    tableRoles.isAvailableBalance === false && {
      title: t("availableBalance"),
      dataIndex: "availableBalanceString",
    },
    {
      title: t("mainCreditLimit"),
      dataIndex: "creditLimitString",
    },
    {
      title: t("availableCreditLimit"),
      dataIndex: "availableCreditLimitString",
    },
    {
      title: t("usedCreditBalance"),
      dataIndex: "creditBalanceString",
    },
    tableRoles.isBlockedBalance === false && {
      title: t("blockedAmount"),
      dataIndex: "blockedAmountString",
    },
    tableRoles.isAvailableCreditBalance === false && {
      title: t("availableCreditBalance"),
      dataIndex: "availableCreditBalanceString",
    },
    {
      title: t("dueDate"),
      dataIndex: "dueDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY") : "-"),
    },
    !tableRoles.isAvailableInterestRate &&
    {
      title: t("interestRate"),
      dataIndex: "interestRate",
    },
    {
      title: t("openDate"),
      dataIndex: "openDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY") : "-"),
    },
    tableRoles.isNetBalance === false ? {
      title: t("netBalance"),
      dataIndex: "netBalanceString"
    } : {},
    isSendTosVirmanUnApproved ? {
      title: t("transferIban"),
      dataIndex: "virmanIban"
    } : {}
  ].filter(Boolean);
  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BankOutlined /> {t("accountList")}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8}>
          <Row justify="end" align="middle" style={{ paddingRight: 16 }}>
            <Tooltip title={t("downloadExcel")}>
              <a
                style={{
                  color: "green",
                  fontSize: "180%",
                  marginRight: 30,
                }}
                onClick={onClickExportExcel}
              >
                <FileExcelOutlined />
              </a>
            </Tooltip>
            <Button
              type="primary"
              onClick={() => {
                setAddCashAccountVisibility(true);
              }}
              style={{ marginBottom: 0 }}
              icon={<PlusOutlined />}
            >
              {t("addCashAccount")}
            </Button>
            {tableDataQueryOptions.activeTab == "3" && isAdmin === true && (
              <Popconfirm
                title={t("areYouSureToDelete")}
                okText={t("okDelete")}
                cancelText={t("noDontDelete")}
                onConfirm={() => handleOnClickMultipleDelete()}
              >
                <a>
                  <Button
                    type="primary"
                    style={{ marginBottom: 0 }}
                    icon={<PlusOutlined />}
                    disabled={selectedRowKeys.length < 1}
                  >
                    {t("deleteAccounts")}
                  </Button>
                </a>
              </Popconfirm>
            )}
          </Row>
        </Col>
      </Row>
      <Tabs defaultActiveKey="1" onChange={onTabChange}>
        <TabPane tab={t("all")} key="1"></TabPane>
        <TabPane tab={t("activeAccounts")} key="2"></TabPane>
        <TabPane tab={t("passiveAccounts")} key="3"></TabPane>
      </Tabs>
      <TenantAccountTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        enableSaveFilter
        hasSavedFilter={hasSavedFilter}
        savedFilterLoading={savedFilterLoading}
        onSaveFilter={saveCurrent}
        onDeleteSavedFilter={deleteCurrent}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            rowSelection={
              isAdmin === true && tableDataQueryOptions.activeTab == "3"
                ? {
                  selectedRowKeys: selectedRowKeys,
                  onChange: onTableSelectChange,
                }
                : undefined
            }
            columns={columns}
            expandable={{
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={t("noData")}
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%" }}
            rowKey="id"
            filterable={true}
            size="small"
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
          />
        </Col>
      </Row>

      <Drawer
        id="addDealerDrawer"
        title={t("addCashAccount")}
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddCashAccountVisibility(false)}
        visible={addCashAccountVisibility}
      >
        <CashAccountAddForm onSuccess={onAddCashAccountSuccess} />
      </Drawer>

      <Drawer
        title={t("editBankAccount")}
        width={241}
        onClose={onCloseUpdate}
        visible={visibleUpdate}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <TenantAccountUpdateForm
          sendDataForUpdate={(val) => {
            if (val === "success") {
              getTableData();
              setVisibleUpdate(false);
            }
          }}
          data={updateFormData}
          isAdmin = {isAdmin}
        />
      </Drawer>
    </>
  );
};

export default BankPage;
